import React from "react";
import { LuInbox } from "react-icons/lu";

const NotFound = ({ title = "No Data Available" }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full py-12 gap-4">
      <div className="relative">
        {/* soft teal glow */}
        <div className="absolute inset-0 rounded-full bg-teal-500/20 blur-2xl" />
        <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-teal-500/15 to-cyan-500/10 border border-teal-400/20 flex items-center justify-center">
          <LuInbox className="w-9 h-9 text-brand-teal" />
        </div>
      </div>
      <div className="text-center">
        <p className="text-sm font-semibold text-main-font">{title}</p>
        <p className="text-xs text-main-subfont mt-1">
          Nothing to show here yet
        </p>
      </div>
    </div>
  );
};

export default NotFound;
